import { mapData } from '@/utilities/DataMapping';
import { Utils } from "@/utilities/Utils";

export interface IEmployeeWithDefaultCheckInTimeVM {

    latestArrivalDefault: Date;
    latestCheckIn: Date;
    employeeName: string;
    employeeGuidID: string;
    latestTime: string;

}

export class EmployeeWithDefaultCheckInTimeVM implements IEmployeeWithDefaultCheckInTimeVM {

    constructor(data?: IEmployeeWithDefaultCheckInTimeVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IEmployeeWithDefaultCheckInTimeVM) {
        mapData(data, {
            root: () => this,
            employee: () => new EmployeeWithDefaultCheckInTimeVM()
        });
    }

    latestArrivalDefault = new Date();
    latestCheckIn = new Date();
    employeeName = "";
    employeeGuidID: string = Utils.emptyGuidValue;
    employeeChecked = false;
    latestArrival = "";

    get latestTime() {
        if (this.latestArrivalDefault && !this.latestCheckIn) {
            return this.latestArrival = this.latestArrivalDefault.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }

        if (this.latestCheckIn) {
            return this.latestArrival = this.latestCheckIn.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }

        return "";
    }

}